import { render, staticRenderFns } from "./Consultations.vue?vue&type=template&id=9cd9af8a"
import script from "./Consultations.vue?vue&type=script&lang=js"
export * from "./Consultations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports